import { useState } from "react";
import logo from "@/assets/logo.svg";
import magnifierWhite from "@/assets/magnifierWhite.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useUrlType } from "../../hooks";
import Burger from "./Burger";

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isPatient } = useUrlType();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="main-header flex items-center justify-between">
      <div className="header-items">
        <img src={logo} className="logo" alt="Logo" />
        {!isPatient && (
          <>
            <ul className="nav-list">
              <li onClick={() => navigate('/')}>Home</li>
              <li className={`${pathname === '/triageList' ? 'active' : ''}`}
                onClick={() => navigate('/triageList')}>Triage</li>
              <li className={`${pathname === '/poaList' ? 'active' : ''}`}
                onClick={() => navigate('/poaList')}>POA List</li>
            </ul>
            <img src={magnifierWhite} className="search" alt="Search" />
          </>
        )}
      </div>
      <Burger sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
    </header>
  );
};

export default Header;